// Horizontal chip row for sorting list views on mobile (and desktop non-tables).
// Tapping an active chip toggles asc/desc. Tapping an inactive chip activates it
// with the provided default direction ("desc" by default).

export function SortChips({ options, sortKey, sortDir, onChange, testIdPrefix, className = "" }) {
  return (
    <div
      className={`flex gap-1.5 overflow-x-auto no-scrollbar -mx-1 px-1 ${className}`}
      data-testid={`${testIdPrefix}-chips`}
    >
      {options.map((opt) => {
        const active = sortKey === opt.key;
        const arrow = active ? (sortDir === "asc" ? "↑" : "↓") : "↕";
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={`shrink-0 px-3 py-1.5 rounded-full text-[11px] font-mono-num uppercase tracking-widest border transition-colors ${
              active
                ? "border-invest/60 bg-invest/10 text-invest"
                : "border-line text-muted-1 hover:text-app hover:border-line-strong"
            }`}
            data-testid={`${testIdPrefix}-${opt.key}`}
            aria-pressed={active}
          >
            {opt.label} <span className={active ? "" : "opacity-50"}>{arrow}</span>
          </button>
        );
      })}
    </div>
  );
}

// Toggle helper — call from parent onChange
export function toggleSort(current, key, defaultDir = "desc") {
  if (current.key === key) {
    return { key, dir: current.dir === "asc" ? "desc" : "asc" };
  }
  return { key, dir: defaultDir };
}

// Generic row sorter — pass an accessor mapping key -> value
export function sortRows(rows, sortKey, sortDir, accessors) {
  if (!sortKey) return rows;
  const acc = accessors[sortKey];
  if (!acc) return rows;
  const sign = sortDir === "asc" ? 1 : -1;
  const copy = [...rows];
  copy.sort((a, b) => {
    const av = acc(a);
    const bv = acc(b);
    // Nulls / undefined go last regardless of direction
    const aNull = av == null || Number.isNaN(av);
    const bNull = bv == null || Number.isNaN(bv);
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;
    if (typeof av === "string" || typeof bv === "string") {
      return sign * String(av).localeCompare(String(bv));
    }
    return sign * (av - bv);
  });
  return copy;
}
